import React from "react";
import { Card, CardContent, Typography, Box, LinearProgress, styled } from "@mui/material";

interface ProgressCardProps {
  title: string;
  percentage: number;
  color: string;
}

const CustomLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== "barColor"
})<{ barColor: string }>(({ barColor }) => ({
  height: 5,
  borderRadius: 5,
  "& .MuiLinearProgress-bar": {
    backgroundColor: barColor,
  },
  backgroundColor: `${barColor}33`,
}));

const ProgressCard: React.FC<ProgressCardProps> = ({ title, percentage, color }) => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="body1" fontWeight="bold">
            {title}
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {percentage}%
          </Typography>
        </Box>
        <CustomLinearProgress variant="determinate" value={percentage} barColor={color} />
      </CardContent>
    </Card>
  );
};

export default ProgressCard;
